import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdc7612c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fdc7612c&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc7612c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdc7612c')) {
      api.createRecord('fdc7612c', component.options)
    } else {
      api.reload('fdc7612c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fdc7612c&scoped=true", function () {
      api.rerender('fdc7612c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paginationMsg/index.vue"
export default component.exports